import { render } from "./SingelOrder.vue?vue&type=template&id=13cf36b3&scoped=true"
import script from "./SingelOrder.vue?vue&type=script&lang=js"
export * from "./SingelOrder.vue?vue&type=script&lang=js"

import "./SingelOrder.vue?vue&type=style&index=0&id=13cf36b3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cf36b3"]])

export default __exports__